import { cloud, moon } from '../motifs';
import { M } from '../palette';
import { registerPlate } from '../registry';

const MOON = ['#fffef4', '#e8e6dc', '#b8b4a8'] as const;
const NIGHT_CLOUD = ['#e4e6f2', '#a2a6c2', '#686c8e'] as const;

/** 20 จันทรา: the moon plate, night blue lacquer under a full moon, grey clouds at both ends. */
registerPlate({
  id: 'moon',
  name: 'จันทรา',
  ground: ['#303868', '#1a1e3c', '#101228'],
  trim: '#a8acd0',
  text: { fill: [M.whiteHi, '#d0d4f0'], line: '#06081a' },
  inset: [14, 14],
  back(p, f) {
    moon(p, f.r - 16, f.y - 5, 13, MOON);
  },
  front(p, f) {
    cloud(p, f.x - 11, f.b + 5, 24, NIGHT_CLOUD);
    cloud(p, f.x - 5, f.y + 8, 14, NIGHT_CLOUD);
    cloud(p, f.r - 14, f.b + 6, 26, NIGHT_CLOUD, true);
    cloud(p, f.r - 34, f.y + 2, 16, NIGHT_CLOUD, true);
  },
  motion: {
    sprites: { wisp: { w: 14, h: 9, draw: (p) => cloud(p, 0, 9, 14, NIGHT_CLOUD) } },
    play(a, t, f) {
      // A cloud drifting slowly across the moon's face.
      a.spr('wisp', f.r - 24 + Math.sin(t * 0.35) * 7, f.y - 11);
    },
  },
});
